import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function getReservations(options) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret, langId } = options;

    invariant(baseUrl, 'baseUrl is a required param of getReservations()');
    invariant(brandId, 'brandId is a required param of getReservations()');
    invariant(country, 'country is a required param of getReservations()');
    invariant(uberToken, 'uberToken is a required param of getReservations()');
    invariant(clientId, 'clientId is a required param of getReservations()');

    const headers = { 'Content-Type': 'application/json' };
    const langIdParam = langId ? `?langId=${langId}` : '';
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/reservations${langIdParam}`;

    return labelRequest(authenticatedRequest(new Request(url, { headers: new Headers(headers) }), uberToken, clientId, clientSecret), 'getReservations');
}
